﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import TKArticleList from '@tk/components/tk.article.list';
import { getCurrentURI, setPersistentView } from '@tk/utilities/tk.storage';
import { fetchRequest } from '@tk/utilities/tk.fetch';

interface LayoutItem {
    id: string;
    className?: string;
}

export default class TKArticleListLayoutSwitch extends TKCustomElementFactory {
    articleList?: TKArticleList;
    layouts: LayoutItem[] = [];
    url?: string;

    constructor() {
        super();
        this.articleList = document.querySelector('[data-tk-article-list-to-switch-layout]') || undefined;
        this.url = this.getAttribute('data-tk-url') || undefined;
    }

    connectedCallback(): void {
        if (!this.articleList || !this.url) throw new Error('TKArticleListLayoutSwitch: Elements are missing!');
        this.initLayouts();
        this.registerLayoutListener();
    }

    initLayouts() {
        const fieldElements = this.querySelectorAll('input');
        fieldElements.forEach((element) => {
            this.layouts.push({
                id: element.value,
                className: element.getAttribute('data-tk-layout-class-name') || undefined,
            });
        });
    }

    registerLayoutListener() {
        const radioElements = this.querySelectorAll('input');
        const onInput = this.handleInput.bind(this);
        radioElements.forEach((element) => {
            this.pushListener({ event: 'input', element, action: onInput });
        });
    }

    handleInput(event: Event) {
        if (!event.target) return;
        const { value } = event.target as HTMLInputElement;
        this.switchLayout(value);
        this.saveSelectedLayout(value);
        setPersistentView(getCurrentURI(), '[data-tk-article-list]');
    }

    switchLayout(id: string) {
        this.layouts.forEach((item) => {
            const className = item.className || '';
            this.articleList!.classList.contains(className) && this.articleList!.classList.remove(className);
        });
        const layoutItem = this.layouts.find((item) => item.id === id);
        layoutItem?.className && this.articleList!.classList.add(layoutItem.className);
    }

    saveSelectedLayout(value: string) {
        const data = {
            value,
        };
        fetchRequest({
            requestURL: this.url!,
            resolveHandler: () => {},
            payload: data,
        });
    }
}
